/**
 * @file コンポーネント：症例アイテム スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledOperation = styled.article`
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 16px;
    background-color: #ffffff;

    &.is-canedit {
        background-color: #eed393;
    }

    > div {
        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const StyledOperationDate = styled.div`
    order: -1;
    margin-bottom: 16px;
    padding: 0 16px;
    color: #000000;
    font-size: 13px;
    line-height: 14.6px;
`;

export const StyledOperationDescription = styled.p`
    display: -webkit-box;
    padding: 0 16px;
    overflow: hidden;
    color: #000000;
    font-size: 13px;
    line-height: 14.6px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
`;

export const StyledOperationMetalist = styled.dl`
    display: flex;
    margin-top: auto;
    padding: 0 16px;
`;

export const StyledOperationMetalistDetail = styled.dd`
    color: #000000;
    font-size: 13px;
    line-height: 14.6px;
`;

export const StyledOperationMetalistItem = styled.div`
    display: flex;
    align-items: center;
    margin-right: 16px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledOperationMetalistTerm = styled.dt`
    display: flex;
    align-items: center;
    width: 24px;
    height: 24px;
    margin-right: 8px;
    color: #000000;
    font-size: 22px;
    line-height: 24px;
    text-align: center;
`;

export const StyledOperationPrice = styled.div`
    margin-bottom: 16px;
    padding: 0 16px;
    text-align: right;
`;

export const StyledOperationPurchaseDate = styled.div`
    order: -1;
    margin-bottom: 16px;
    padding: 0 16px;
    color: #00b700;
    font-weight: bold;
    font-size: 13px;
    line-height: 14.6px;
`;

export const StyledOperationPurchaseId = styled.div`
    order: -1;
    margin-bottom: 16px;
    padding: 0 16px;
    color: #000000;
    font-weight: bold;
    font-size: 13px;
    line-height: 14.6px;
`;

export const StyledOperationSurgeonlist = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;
    padding: 0 16px;
`;

export const StyledOperationThumbnail = styled.div`
    order: -2;
    margin-bottom: 16px;
`;

export const StyledOperationThumbnailAnchor = styled.a`
    display: block;
    position: relative;
    overflow: hidden;

    &::before {
        display: block;
        padding-top: 56.25%;
        content: "";
    }

    &:hover {
        > img {
            opacity: 1;
        }
    }
`;

export const StyledOperationThumbnailImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    max-width: inherit;
`;

export const StyledOperationThumbnailImageAnimation = styled.img`
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    max-width: inherit;
`;

export const StyledOperationTitle = styled.div`
    margin-bottom: 16px;
    padding: 0 16px;
    height: 31.4px;
    color: #000000;
`;

export const StyledOperationTitleAnchor = styled.a`
    display: -webkit-box;
    overflow: hidden;
    color: #000000;
    font-weight: normal;
    font-size: 14px;
    line-height: 15.7px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

export const StyledOperationIconMetalist = styled.dl`
    display: flex;
    margin-top: auto;
    padding: 0 16px;
    margin-left: auto;  /* 右寄せ */
`;

export const StyledOperationIconMetalistItem = styled.div`
    display: flex;
    align-items: center;
    margin-right: 8px;

    &:last-of-type {
        margin-right: 0;
    }
`;

export const StyledOperationIconMetalistTermAnotherTab = styled.dt`
    display: flex;
    align-items: center;
    width: 14px;
    height: 14px;
    margin-right: 0px;
    color: #808080;
    font-size: 14px;
    line-height: 14px;
    text-align: center;
`;

export const StyledOperationIconMetalistTermPromotion = styled.dt`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 16px;
    margin-right: 0px;
    background-color: #C5C5C5;
    color: #ffffff;
    font-size: 12px;
    font-weight: normal;
    border-radius: 4px;
`;
